import React from "react";
import { FaAngleRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Badge, Col } from "reactstrap";
import { categories, recentPosts, tags } from "../Data/Blogdata/Blogdata";

const Sidebar = ({align}) => {
  return (
    <Col md={4} lg={3} className={`order-md-${align} list-sidebar`}>
      <div className='sidebar'>
        <div className='sidebar-space'>
          <h4 className='blog-title'>blog Category</h4>
          <div className='blog-divider'></div>
          <div className='blog-cat-detail'>
            <ul>
              {categories.map((category, index) => (
                <li className='marg-15' key={index}>
                  <Link to={`${process.env.PUBLIC_URL}/blog-details`}>
                    <FaAngleRight/> {category}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className='sidebar-space'>
          <h4 className='blog-title'>Popular Tag</h4>
          <div className='blog-divider'></div>
          <div className='tags marg-20'>
            {tags.map((tag, index) => (
              <Link key={index}>
                <Badge color="" className='badge-theme'>{tag}</Badge>
              </Link>
            ))}
          </div>
        </div>
        <h4 className='blog-title'>Recent Post</h4>
        <div className='blog-divider'></div>
        <div className='recent-blog marg-20'>
          {recentPosts.map((post, index) => (
            <div className='media d-flex align-items-center' key={index}>
              <img className='me-3' src={post.image} alt='blog' />
              <div className='media-body'>
                <Link className="text-decoration-none" to={`${process.env.PUBLIC_URL}/blog-details`}>
                  <h5 className='mt-0'>{post.title}</h5>
                </Link>
                <p className='m-0'>{post.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Col>
  );
};

export default Sidebar;
